/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Image_HeaderInputs */

const vi_product_image_header = /** @type {(inputs: Product_Image_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh`)
};

/**

* @param {Product_Image_HeaderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_image_header = /** @type {((inputs?: Product_Image_HeaderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Image_HeaderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_image_header(inputs)
});